import _ from 'lodash';

export function getFullName(user) {
  const fullName =
    `${_.get(user, 'firstName', '')}` + ` ${_.get(user, 'lastName', '')}`;
  return fullName;
}

export function getDateRange(booking) {
  const startDate = new Date(booking?.startDate).toLocaleDateString();
  const endDate = new Date(booking?.endDate).toLocaleDateString();
  const date = startDate + ' to ' + endDate;
  return date;
}

export const BytesToMetricSize = (bytes, decimals = 2) => {
  const d = Math.floor(Math.log(bytes) / Math.log(1024));
  return bytes === 0
    ? '0 Bytes'
    : parseFloat((bytes / Math.pow(1024, d)).toFixed(Math.max(0, decimals))) +
        ' ' +
        ['Bytes', 'KB', 'MB', 'GB'][d];
};

export const envDomainMap = {
  dev: 'student-dev.almagrow.com',
  qa: 'student-qa.almagrow.com',
  prod: 'grow.almabetter.com',
};

export const copyToClipboard = (url) => {
  return navigator.clipboard.writeText(url);
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const validate10digitPhoneNo = (phone) => {
  const re = /^\d+$/;
  return re.test(phone) && phone.length === 10;
};

export const filterLatestClasses = (classes) => {
  const filteredClasses = classes.sort(
    (a, b) => new Date(b.startTime) - new Date(a.startTime)
  );
  return filteredClasses;
};
